import { AxiosRequestConfig } from 'axios';
import axiosClient from './request-client';

export type DiffStatus = 'CONFLICT' | 'ONLY_APP' | 'ONLY_SHEET';

export type DiffEntry = {
  key: string;
  status: DiffStatus;
  warehouseId: number;
  tabTitle: string;
  name: string;
  code: string;
  rarity: string;
  language: string;
  appQuantity: number | null;
  sheetQuantity: number | null;
  dbId: number | null;
  rowNumber: number | null;
  konamiId: number;
  cardSetId: number;
  state: string;
};

export type ResolutionAction =
  | 'USE_APP'
  | 'USE_SHEET'
  | 'PUSH_TO_SHEET'
  | 'PULL_TO_APP'
  | 'DELETE_APP'
  | 'DELETE_SHEET'
  | 'IGNORE';

export type Resolution = { entry: DiffEntry; action: ResolutionAction };

export const getStatus = (config?: AxiosRequestConfig) =>
  axiosClient.get(`/google-sheets/status`, config);

export const getAuthUrl = (config?: AxiosRequestConfig) =>
  axiosClient.get(`/google-sheets/authorize`, config);

export const connect = (
  body: { spreadsheetId?: string; createNew?: boolean },
  config?: AxiosRequestConfig
) => axiosClient.post(`/google-sheets/connect`, body, config);

export const disconnect = (config?: AxiosRequestConfig) =>
  axiosClient.delete(`/google-sheets/disconnect`, config);

export const preview = (config?: AxiosRequestConfig) =>
  axiosClient.post(`/google-sheets/preview`, {}, config);

export const apply = (
  body: { resolutions: Resolution[] },
  config?: AxiosRequestConfig
) => axiosClient.post(`/google-sheets/apply`, body, config);
